const SITE_NAME = 'Main Street Bread'
const DEFAULT_DESCRIPTION =
  'Main Street Bread — a family-run artisan bakery in Ferndale, crafting fresh bread, pastries, and community one loaf at a time.'
const SITE_URL = import.meta.env.VITE_SITE_URL ?? 'https://mainstreet-bread.com'
const DEFAULT_OG_IMAGE = `${SITE_URL}/images/og-default.jpg`

interface SeoOptions {
  title?: string
  description?: string
  path?: string
  image?: string
  type?: 'website' | 'article'
  article?: {
    publishedTime?: string
    author?: string
    tags?: string[]
  }
}

export function seoMeta({
  title,
  description = DEFAULT_DESCRIPTION,
  path = '/',
  image = DEFAULT_OG_IMAGE,
  type = 'website',
  article,
}: SeoOptions = {}) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME
  const url = `${SITE_URL}${path}`
  const absoluteImage = image.startsWith('http') ? image : `${SITE_URL}${image}`

  const meta: Array<Record<string, string>> = [
    { title: fullTitle },
    { name: 'description', content: description },

    // Open Graph
    { property: 'og:title', content: fullTitle },
    { property: 'og:description', content: description },
    { property: 'og:url', content: url },
    { property: 'og:type', content: type },
    { property: 'og:image', content: absoluteImage },
    { property: 'og:site_name', content: SITE_NAME },
    { property: 'og:locale', content: 'en_US' },
  ]

  if (article) {
    if (article.publishedTime) {
      meta.push({ property: 'article:published_time', content: article.publishedTime })
    }
    if (article.author) {
      meta.push({ property: 'article:author', content: article.author })
    }
    if (article.tags) {
      for (const tag of article.tags) {
        meta.push({ property: 'article:tag', content: tag })
      }
    }
  }

  return meta
}

export function canonicalLink(path: string) {
  return { rel: 'canonical', href: `${SITE_URL}${path}` }
}

export { SITE_URL, SITE_NAME }
